import { FORM_EMAIL_FIELD_NODE_NAME, FORM_SUBMIT_BUTTON_NODE_NAME } from '@/utils/constants';
import type { useEditorReturnType } from '@craftjs/core';
import { isSingleRootContainer } from './helperFunc';

/**
 * Shared deletability check used by canvas controls and the layers panel.
 * Combines Craft's deletable flag with our custom rules.
 */
export function canDeleteNode(query: useEditorReturnType['query'] | null, nodeId: string): boolean {
  if (!query) return false;
  const node = query.node(nodeId).get();
  if (!node) return false;

  // Start with Craft's default deletable check
  let deletable = query.node(nodeId).isDeletable();

  // Custom rules
  if (deletable) {
    if (node.data.displayName === FORM_EMAIL_FIELD_NODE_NAME) {
      // Never allow a primary email field to be deleted
      deletable = !node.data.props?.primaryEmailField;
    } else if (node.data.displayName === FORM_SUBMIT_BUTTON_NODE_NAME) {
      // Never allow a form submit button to be deleted
      deletable = false;
    } else if (isSingleRootContainer(node, query)) {
      deletable = false;
    }
  }

  return !!deletable;
}
